import { formatDate } from "date-fns"
import { Task, UserRole } from "../../../../../types"
import { EditIcon } from "../../../../components/button/IconButton"
import styles from "./view-task.module.css"
import { formatTimeDelta } from "../../../../lib/formatTimeDelta"
import { Button } from "../../../../components/button/Button"
import classNames from "classnames"
import { isBitus } from "../../../../../config/urls"
import { useWatcher } from "../../../../lib/state/useWatcher"
import { userState } from "../../../../store/user"
import { hasUserAccess } from "@/utils/user"

// status
// TaskStatus_Created         TaskStatus = 0
// TaskStatus_Approved        TaskStatus = 1
// TaskStatus_StatusToStarted TaskStatus = 2
// TaskStatus_StatusToDone    TaskStatus = 3
//

export const HistoryItem = ({
  task,
  onEdit,
  isPrivateTask = false,
}: {
  task: Task & { name?: string }
  onEdit?: (task: Task) => void
  isPrivateTask?: boolean
}) => {
  const user = useWatcher(userState)

  const canSeeTask =
    isPrivateTask ||
    user.id === task.user?.id ||
    hasUserAccess({
      neededRole: UserRole.Manager,
      userRole: user.role,
    })

  if (!canSeeTask) return null

  if (task.deletedAt) {
    // hide if deleted by the user themselves
    if (task.deletedBy === user.id) return null

    return (
      <div key={task.id} className={styles.historyItem} style={{ opacity: 0.5 }}>
        <div className={styles.historyLeftSide}>
          <div>
            <div className={styles.historyName}>
              {task.name ?? task.user?.name ?? "-"}
            </div>
            <div className={styles.historyError}>
              {task.deletedByName ?? "Lietotājs"} ir dzēsis šo uzdevumu
              {task.deletedComment ? `: ${task.deletedComment}` : ""}
            </div>
            <div className={styles.historyDate}>
              {formatDate(new Date(task.date), "dd.MM.yyyy")}
            </div>
          </div>
        </div>
      </div>
    )
  }

  // error
  if (task.status === 4) {
    return (
      <div key={task.id} className={styles.historyItem}>
        <div className={styles.historyLeftSide}>
          <div>
            <div className={styles.historyName}>
              {task.name ?? task.user?.name ?? "-"}
            </div>
            <div className={styles.historyError}>Reģistrēja defektu</div>
            <div>{task.comment}</div>
            <div>{task.target}</div>

            <div className={styles.historyDate}>
              {formatDate(new Date(task.date), "dd.MM.yyyy")}
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (task.status === 2) {
    return (
      <div key={task.id} className={styles.historyItem}>
        <div className={styles.historyLeftSide}>
          <div>
            <div className={styles.historyName}>
              {task.name ?? task.user?.name ?? "-"}
            </div>
            <div className={styles.historyDate}>
              {formatDate(new Date(task.date), "dd.MM.yyyy")}
            </div>
          </div>
        </div>
        <div className={classNames(styles.historyCount, styles.historyDanger)}>
          Atzīmēja kā nepabeigtu
        </div>
      </div>
    )
  }

  if (task.status === 3) {
    return (
      <div key={task.id} className={styles.historyItem}>
        <div className={styles.historyLeftSide}>
          <div>
            <div className={styles.historyName}>
              {task.name ?? task.user?.name ?? "-"}
            </div>
            <div className={styles.historyDate}>
              {formatDate(new Date(task.date), "dd.MM.yyyy")}
            </div>
          </div>
        </div>
        <div className={classNames(styles.historyCount, styles.historySuccess)}>
          Atzīmēja kā pabeigtu
        </div>
      </div>
    )
  }
  return (
    <div key={task.id} className={styles.historyItem}>
      <div className={styles.historyLeftSide}>
        <div>
          {task?.projectName && task?.subProjectName ? (
            <div className={styles.projectName}>
              {task.projectName} - {task.subProjectName}
            </div>
          ) : null}
          <div className={styles.historyName}>
            {task.opGroupName ? `${task.opGroupName} / ` : ``}
            {task.name ?? task.user?.name ?? "-"}
          </div>
          {!!task.comment && (
            <div className={styles.blockQuote}>{task.comment}</div>
          )}
          <div className={styles.historyDate}>
            {formatDate(new Date(task.date), "dd.MM.yyyy")}
          </div>
        </div>
      </div>
      <div className={styles.historyRightSide}>
        {onEdit && task.status < 1 && task.user?.id === user.id ? (
          <div>
            <Button variant="secondary" onClick={() => onEdit(task)}>
              Labot {EditIcon}
            </Button>
          </div>
        ) : null}
        <div className={styles.historyCount}>
          {isBitus ? (
            <div>{task.unitsUsed ?? 0} gb.</div>
          ) : task.salaryUsed ? (
            <div>{task.salaryUsed / 100}€</div>
          ) : null}
          <div>{formatTimeDelta(task.timeUsed)}</div>
        </div>
      </div>
    </div>
  )
}
